'use client';

import { useEffect } from 'react';
import { trpc } from '@/lib/trpc';
import { useAuth } from '@/hooks/use-auth';
import { useTenant } from '@/hooks/use-tenant';
import { useCampaignConfigStore } from '@/stores/campaign-config-store';

export function CampaignConfigProvider({ children }: { children: React.ReactNode }) {
  const tenantId = useTenant();
  const { isAuthenticated } = useAuth({ hydrateFromQuery: true });
  const setCampaignConfig = useCampaignConfigStore((state) => state.setCampaignConfig);
  const clearCampaignConfig = useCampaignConfigStore((state) => state.clearCampaignConfig);

  const { data } = trpc.tenantConfig.get.useQuery(undefined, {
    enabled: !!tenantId && isAuthenticated,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (data) {
      setCampaignConfig(data);
    }
  }, [data, setCampaignConfig]);

  useEffect(() => {
    if (!tenantId) {
      clearCampaignConfig();
    }
  }, [tenantId, clearCampaignConfig]);

  return <>{children}</>;
}
